// TODO: move this component to qampo-ui-library.
// qampo-ui-library exports a StatusChip, but it only accepts `status: string`
// plus CSS overrides — no ReactNode label, no tooltip slot, no custom icon —
// so Tag is retained until the library gains an equivalent slot-based API.
import type { ReactNode } from 'react';
import { Tooltip } from './Tooltip';
import styles from './Tag.module.css';

export type TagSize = 'default' | 'small';

export interface TagProps {
  label: ReactNode;
  tooltip?: ReactNode;
  onRemove?: () => void;
  removeAriaLabel?: string;
  // Turns the pill itself into a button. Mutually exclusive with onRemove —
  // a nested remove button inside a button is invalid HTML.
  onClick?: () => void;
  clickAriaLabel?: string;
  size?: TagSize;
  className?: string;
}

export const Tag = ({
  label,
  tooltip,
  onRemove,
  removeAriaLabel,
  onClick,
  clickAriaLabel,
  size = 'default',
  className
}: TagProps) => {
  const classes = [
    styles.tag,
    size === 'small' && styles.small,
    onClick && styles.clickable,
    className
  ]
    .filter(Boolean)
    .join(' ');
  const pill = onClick ? (
    <button type="button" className={classes} aria-label={clickAriaLabel} onClick={onClick}>
      {label}
    </button>
  ) : (
    <span className={classes}>
      {label}
      {onRemove && (
        <button
          type="button"
          className={styles.remove}
          aria-label={removeAriaLabel}
          onClick={onRemove}
        >
          &times;
        </button>
      )}
    </span>
  );

  if (tooltip === undefined) return pill;

  return <Tooltip trigger={pill} content={tooltip} />;
};
